// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10di9","label":"styles_label__2jPet"};